module.exports = __webpack_public_path__ + "img/pr-5.ddf0081a.png";